var map = {
	"./CSC.jpg": 114,
	"./IMG_20190712_151343.jpg": 115,
	"./UTMSAM.png": 116,
	"./animate-logo.png": 117,
	"./ata.jpeg": 118,
	"./ata.jpg": 119,
	"./bootstrap-logo.png": 120,
	"./chessboard.png": 121,
	"./covid.png": 122,
	"./cursor.svg": 123,
	"./desk.svg": 124,
	"./doodles.png": 125,
	"./flatcolours-bg.png": 126,
	"./github.svg": 127,
	"./hamburger-menu.svg": 128,
	"./handlebars-logo.svg": 129,
	"./heart.svg": 130,
	"./incident.jpg": 131,
	"./langtools.jpg": 132,
	"./lara.png": 133,
	"./logo.svg": 134,
	"./me.jpg": 135,
	"./money-bg.jpg": 136,
	"./mongodb-logo.png": 137,
	"./nfc-logo.png": 138,
	"./nodejs-logo.png": 139,
	"./photoshop-logo.png": 140,
	"./profile_pic.jpg": 35,
	"./profile_pic2.jpg": 141,
	"./prolora.png": 142,
	"./rpg-adventure-bg.png": 143,
	"./simplejson.jpg": 144,
	"./socketio-logo.svg": 145,
	"./sodoku-bg.jpg": 146,
	"./splunk.jpg": 147,
	"./spotify.jpg": 148,
	"./spotify.png": 149,
	"./tetris.jpg": 150,
	"./transport.png": 151,
	"./waterloop.png": 152,
	"./waterloop.svg": 153,
	"./wathub.png": 154,
	"./watonomous.jpg": 155,
	"./watonomous.png": 156,
	"./yorkregion.jpg": 157,
	"./yorkregion.png": 158
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*$
// module id = 37
// module chunks = 0